import React, { useEffect } from "react";
import clsx from "clsx";
import {
  Typography,
  withStyles,
  Avatar,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Collapse,
  IconButton,
  Tooltip,
  createMuiTheme,
  MuiThemeProvider,
  List,
  ListItem,
  ListItemText,
  Menu,
  MenuItem,
  Divider,
  Grid
} from "@material-ui/core";
import API, { graphqlOperation } from "@aws-amplify/api";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import { Chat } from "@material-ui/icons";
import CropFreeIcon from "@material-ui/icons/CropFree";
import ShareIcon from "@material-ui/icons/Share";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import TranslateIcon from "@material-ui/icons/Translate";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import uuid from "uuid/v4";
import axios from "axios";
import { Auth } from "aws-amplify";

import {
  getBotInformations,
  listAdminPermissionss
} from "../../../graphql/queries";
import ForwardLogo from "./fast-forward.svg";
import ReverseLogo from "./fast-reverse.svg";
import MessageActions from "./MessageActions";
import ChatTagAction from "./chatTagAction";
import ChatTagActionSent from "./chatTagActionSent";
import CommentAction from "./commentAction";
import MessageData from "./messageData";
import ShareAction from "./ShareAction";
import ExpertAction from "./ExpertAction";
import { QRCode } from "../../QRCode";
import Dictate from "../../AI/Dictate";
import DetectSentiment from "../../AI/DetectSentiment";
import DetectEntities from "../../AI/DetectEntities";
import TranslateCard from "../../AI/TranslateCard";
import awsConfig from "../../../aws-exports";
import useStyles from "./styles";

const VISIBILITY = "protected";

const LightTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11
  }
}))(Tooltip);

interface IMessageBubbleProps {
  message: {
    owner: String;
    content: String;
    createdAt: string;
    id: any;
    chatbot: boolean;
    isSent: boolean;
    messageConversationId: String;
  };
  authorId: String;
  autoMsg: any;
  botText: any;
  client: any;
  saveChatTagDataMain: any;
  saveSliderDataMain: any;
  setQRScroll: any;
}

const theme = createMuiTheme({
  overrides: {
    MuiIconButton: {
      root: {
        fontSize: "0.8rem",
        padding: 8,
        paddingRight: 0
      }
    }
  }
});

const MessageBubble: React.FC<IMessageBubbleProps> = ({
  message,
  authorId,
  autoMsg,
  botText,
  client,
  saveChatTagDataMain,
  saveSliderDataMain,
  setQRScroll
}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [ViewMore, setViewMore] = React.useState(false);
  const [ViewLess, setViewLess] = React.useState(false);
  const [mainData, setMainData] = React.useState();
  const [PermissionData, setPermissionData] = React.useState();
  const [actionOpen, setActionOpen] = React.useState(false);
  const [chatOpen, setChatOpen] = React.useState(false);
  const [chatOpenSent, setChatOpenSent] = React.useState(false);
  const [mic, setMic] = React.useState(false);
  const [commentOpen, setCommentOpen] = React.useState(false);
  const [selectedLanguage, setSelectedLanguage] = React.useState(null);
  const [keyPath, setKeyPath] = React.useState("en");
  const [dictate, setDictate] = React.useState(false);
  const [bucket, setBucket] = React.useState(
    awsConfig.aws_user_files_s3_bucket
  );
  const [sentiment, setSentiment] = React.useState(false);
  const [dynamoData, setdynamoData] = React.useState();
  const [sloteData, setSloteData] = React.useState();
  const [navigationIndex, setNavigationIndex] = React.useState(0);
  const [navigationIndexChap, setNavigationIndexChap] = React.useState(0);
  const [voice, setVoice] = React.useState("");
  const [toDictate, setToDictate] = React.useState(null);
  const [messageData, setmessageData] = React.useState(message.content);
  const [expanded, setExpanded] = React.useState(false);
  const [shareOpen, setShareOpen] = React.useState(false);
  const [expertOpen, setExpertOpen] = React.useState(false);
  const [anchorElData, setAnchorElData] = React.useState(null);
  const [sponsorAnchorEl, setSponsorAnchorEl] = React.useState(null);
  const [relatedData, setrelatedData] = React.useState([]);
  const [groupData, setgroupData] = React.useState([]);
  const [sponsorData, setSponsorData] = React.useState([]);
  const [openData, setOpenData] = React.useState(false);
  const [botInfo, setBotInfo]: any = React.useState({});
  const [nextData, setNextData]: any = React.useState();
  const [nextDataChap, setNextDataChap]: any = React.useState();

  const open = Boolean(anchorElData);
  const sponsorOpen = Boolean(sponsorAnchorEl);

  let index = 0;

  useEffect(() => {
    listExpert();
    AdminPermission();
    setMainData(botText);
    DynamoData();
  }, []);

  const DynamoData = () => {
    let allDynamoData: any = localStorage.getItem("alldataMain");
    setdynamoData(allDynamoData);
    let slugMain: any = localStorage.getItem("allSlugMain");
    setSloteData(slugMain);
  };

  var options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  };
  let abc = message.createdAt;

  let date =
    abc != "sending..." ? new Date().toLocaleString("en-US", options) : abc;

  let mainDataRes;

  const AdminPermission = async () => {
    const userMutation: any = await API.graphql(
      graphqlOperation(listAdminPermissionss, {
        filter: {
          roleName: { contains: "HoneyCode glossary chat" }
        },
        limit: 100
      })
    );
    const mutationResponse = await Promise.all([userMutation]);
    mainDataRes = mutationResponse[0].data.listAdminPermissions.items[0];
    setPermissionData(mainDataRes);
  };

  const viewMore = () => {
    setViewMore(true);
  };

  const viewLess = () => {
    setViewMore(false);
    setViewLess(true);
  };

  const closeActionMenu = () => {
    setActionOpen(false);
  };

  const callDictate = () => {
    doDictate(message.content, true);
    setActionOpen(false);
  };

  const dictateTranslated = () => {
    doDictate(messageData, false);
  };

  const doDictate = async (messageTape: any, original: Boolean) => {
    const { identityId } = await Auth.currentCredentials();
    const key = `${VISIBILITY}/${identityId}/${uuid()}`;
    let voice = "Russell";
    if (selectedLanguage === "ar") {
      voice = "Zeina";
    } else if (selectedLanguage === "zh") {
      voice = "Zhiyu";
    } else if (selectedLanguage === "da") {
      voice = "Mads";
    } else if (selectedLanguage === "nl") {
      voice = "Ruben";
    } else if (selectedLanguage === "en") {
      voice = "Nicole";
    } else if (selectedLanguage === "fr") {
      voice = "Mathieu";
    } else if (selectedLanguage === "de") {
      voice = "Marlene";
    } else if (selectedLanguage === "is") {
      voice = "Dora";
    } else if (selectedLanguage === "hi") {
      voice = "Aditi";
    } else if (selectedLanguage === "it") {
      voice = "Giorgio";
    } else if (selectedLanguage === "ja") {
      voice = "Mizuki";
    } else if (selectedLanguage === "ko") {
      voice = "Seoyeon";
    } else if (selectedLanguage === "nb") {
      voice = "Liv";
    } else if (selectedLanguage === "pl") {
      voice = "Jacek";
    } else if (selectedLanguage === "pt") {
      voice = "Cristiano";
    } else if (selectedLanguage === "ro") {
      voice = "Carmen";
    } else if (selectedLanguage === "ru") {
      voice = "Maxim";
    } else if (selectedLanguage === "es") {
      voice = "Enrique";
    } else if (selectedLanguage === "sv") {
      voice = "Astrid";
    } else if (selectedLanguage === "tr") {
      voice = "Filiz";
    } else if (selectedLanguage === "cy") {
      voice = "Gwyneth";
    }
    setKeyPath(key);
    setVoice(voice);
    setToDictate(messageTape);
    setDictate(true);
  };

  const finishedDictating = () => {
    setDictate(false);
  };

  const setTranslation = (code: any) => {
    if (code === "he") {
      setMic(true);
    } else {
      setMic(false);
    }
    setSelectedLanguage(code);
    setActionOpen(false);
  };

  const openMessageAction = (event: any) => {
    setActionOpen(true);
    setAnchorEl(event.currentTarget);
  };

  const comprehend = () => {
    setSentiment(true);
    setActionOpen(false);
  };

  const closeTranslateCard = () => {
    setSelectedLanguage(null);
    setDictate(false);
  };

  const closeDictateCard = () => {
    // setSelectedLanguage(null);
    setDictate(false);
    setActionOpen(false);
  };

  const applyState = (state: any) => {
    setmessageData(state.translated);
  };

  const openDesc = (resp: any) => {
    autoMsg(resp);
  };

  const chaTag = () => {
    setActionOpen(false);
    setChatOpen(true);
  };

  const chaTagSentiment = () => {
    setActionOpen(false);
    setChatOpenSent(true);
  };

  const closeChatTag = () => {
    setChatOpen(false);
  };

  const closeChatTagSent = () => {
    setChatOpenSent(false);
  };

  const addComment = () => {
    setActionOpen(false);
    setCommentOpen(true);
  };

  const closeComment = () => {
    setCommentOpen(false);
  };

  const saveChatTag = async (data: any) => {
    let slugData: any = localStorage.getItem("slugTerm");
    let sludDetail =
      slugData.length > 0
        ? slugData
            .split("Define")[1]
            .trim()
            .replace(" ", "-")
            .toLowerCase()
        : "aws";

    let total = 0;
    Object.keys(data.sliderValue).map((k: string) => {
      total += parseInt(data.sliderValue[k]) / 10;
    });

    axios
      .post(`${process.env.REACT_APP_MESSAGEBUBBLE_URL}`, {
        siteId: process.env.REACT_APP_MESSAGEBUBBLE_SITEID,
        slugId: `${sludDetail}#${localStorage.getItem("randUserIdAws")}`,
        total: total,
        data: JSON.stringify(data.sliderLabels)
      })
      .then(function(response) {
        setChatOpen(false);
        alert("Add chatTag successfully");
      })
      .catch(function(error) {
        console.log("error: ", error);
      });
  };

  const checkJson = (message: any) => {
    try {
      return JSON.parse(message);
    } catch (error) {
      return {
        Hebrew: 0,
        English_Rashi_Commentary: "",
        Hebrew_Tanach_Nikud: "",
        Hebrew_Tanach_Text: "",
        German: "",
        French: "",
        English_JPS17: "",
        content: message
      };
    }
  };

  const saveChatTageData = (data: any) => {
    saveChatTagDataMain(data);
    closeChatTagSent();
  };

  const handleChangeData = (event: any, value: any) => {
    let slidersData = value / 10;
    saveSliderDataMain(slidersData);
  };

  const QRCodes = () => {
    setExpanded(!expanded);
    setQRScroll();
    setActionOpen(false);
  };

  const setShare = () => {
    setShareOpen(true);
    setActionOpen(false);
  };

  const closeShare = () => {
    setShareOpen(false);
  };

  const setExpert = () => {
    setExpertOpen(true);
    setActionOpen(false);
  };

  const closeExpert = () => {
    setExpertOpen(false);
  };

  const listExpert = async () => {
    // Query using a parameter
    const userMutation: any = await API.graphql(
      graphqlOperation(getBotInformations, {
        filter: {
          id: { eq: "69238cfb-8f29-471c-bf4b-920a88e2f468" }
        },
        limit: 100
      })
    );
    const mutationResponse = await Promise.all([userMutation]);
    setBotInfo(mutationResponse[0].data.listBotInformations.items[0]);
    let DataMain =
      mutationResponse[0].data.listBotInformations.items[0].Related;
    let main = DataMain.map((data: any) => data);
    let GroupData =
      mutationResponse[0].data.listBotInformations.items[0].Groups;
    let GroupMain = GroupData.map((data: any) => data);
    let SponsoredData =
      mutationResponse[0].data.listBotInformations.items[0].Sponsored;
    let SponsoredMain = SponsoredData.map((data: any) => data);
    setrelatedData(main);
    setgroupData(GroupMain);
    setSponsorData(SponsoredMain);
  };

  const handleClick = (event: any) => {
    setAnchorElData(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElData(null);
  };

  const sponsorHandleClick = (event: any) => {
    setSponsorAnchorEl(event.currentTarget);
  };

  const sponsorHandleClose = () => {
    setSponsorAnchorEl(null);
  };

  const handleClickGroup = () => {
    setOpenData(!openData);
  };

  const slugInadexNum = () => {
    let slugPass: any = sloteData && JSON.parse(sloteData);
    let DefineSlots = message && checkJson(message.content).term.toLowerCase();
    const isLargeNumber = (slugPass: any) => slugPass === DefineSlots;
    let slugIndex: number = slugPass.findIndex(isLargeNumber);
    index = slugIndex;
    setNavigationIndex(index);
  };

  const handleBackData = async (data: any) => {
    let leftData: any;
    let DynamoMainSet: any = dynamoData && JSON.parse(dynamoData);
    slugInadexNum();
    if (data === "left") {
      if (navigationIndex === 0) {
        setNavigationIndex(--index);
        leftData = DynamoMainSet && JSON.parse(dynamoData)[index];
        setNextData(leftData);
      } else {
        setNavigationIndex(navigationIndex - 1);
        leftData = DynamoMainSet && JSON.parse(dynamoData)[navigationIndex - 1];
        setNextData(leftData);
      }
    }
    if (data === "right") {
      if (navigationIndex === 0) {
        setNavigationIndex(++index);
        leftData = DynamoMainSet && JSON.parse(dynamoData)[index];
        setNextData(leftData);
      } else {
        setNavigationIndex(navigationIndex + 1);
        leftData = DynamoMainSet && JSON.parse(dynamoData)[navigationIndex + 1];
        setNextData(leftData);
      }
      if (navigationIndex === 256) {
        setNavigationIndex(256);
        leftData = DynamoMainSet && JSON.parse(dynamoData)[256];
        setNextData(leftData);
      }
    }
  };

  return !message.chatbot ? (
    <div key={message.id} className={classes.messageBubbleContainer}>
      <div className={classes.botText}>
        <Typography
          variant="body1"
          gutterBottom
          color="inherit"
          className={classes.messageType}
        >
          {message.content}
        </Typography>
        <div className={classes.timestamp}>
          <div />
          <Typography
            variant="caption"
            gutterBottom
            color="inherit"
            className={classes.messageTypeData}
          >
            {date}
          </Typography>
        </div>
      </div>
    </div>
  ) : (
    <MuiThemeProvider theme={theme}>
      <div key={message.id} className={classes.messageBubbleContainer}>
        <MessageActions
          actionOpen={actionOpen}
          callSetAction={() => closeActionMenu()}
          callDictate={() => callDictate()}
          setTranslation={setTranslation}
          comprehend={() => comprehend()}
          anchorEl={anchorEl}
          setExpanded={() => QRCodes()}
          addComment={() => addComment()}
          messageData={message.content}
          setShare={() => setShare()}
          setExpert={() => setExpert()}
          setSponsorData={sponsorData}
          PermissionData={PermissionData}
        />
        <Menu
          id="long-menu"
          anchorEl={anchorElData}
          keepMounted
          open={open}
          onClose={handleClose}
          PaperProps={{
            style: {
              maxHeight: 48 * 4.5,
              width: 200
            }
          }}
        >
          {relatedData.map((relatedData: any) => (
            <a
              href={relatedData.link}
              style={{ color: "black" }}
              target="_blank"
            >
              <MenuItem key={relatedData} onClick={handleClose}>
                {relatedData.name}
                <Divider />
              </MenuItem>
            </a>
          ))}
          <ListItem button onClick={handleClickGroup}>
            <ListItemText primary="Groups" />
            {openData ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openData} timeout="auto" unmountOnExit>
            <List disablePadding>
              {groupData.map((data: any) => (
                <ListItem
                  button
                  className={classes.nested}
                  onClick={handleClose}
                >
                  <ListItemText primary={data} />
                </ListItem>
              ))}
            </List>
          </Collapse>
        </Menu>
        <Card className={classes.card}>
          <CardHeader
            avatar={
              <Avatar
                aria-label="nopacLogo192"
                src={botInfo && botInfo.BotLogo}
              />
            }
            action={
              <div>
                {PermissionData &&
                PermissionData.Permissions.indexOf("related") > -1 ? (
                  <IconButton
                    aria-owns={"message-actions"}
                    aria-haspopup="true"
                    onClick={handleClick}
                  >
                    <span style={{ verticalAlign: "super" }}>RELATED</span>
                    {open ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                ) : (
                  ""
                )}
              </div>
            }
            title="HoneyCode.glossary.chat"
            subheader={date}
          />
          {(message && checkJson(message.content).isMultiple) ||
          message.content.includes("Glossary") ||
          ViewMore !== false ||
          message.content.includes("don't") ? (
            ""
          ) : (
            <img
              src={ReverseLogo}
              onClick={() => handleBackData("left")}
              style={{
                marginLeft: "3%",
                width: "23px"
              }}
            />
          )}
          {(message && checkJson(message.content).isMultiple) ||
          message.content.includes("Glossary") ||
          ViewMore !== false ||
          message.content.includes("don't") ? (
            ""
          ) : (
            <img
              src={ForwardLogo}
              onClick={() => handleBackData("right")}
              style={{
                marginLeft: "83%",
                width: "23px"
              }}
            />
          )}
          <CardContent>
            <Typography variant="body2" color="textSecondary" component="p">
              {nextData && nextData ? (
                <MessageData
                  content={nextData}
                  viewMoreEvent={viewMore}
                  viewLessEvent={viewLess}
                  viewMore={ViewMore}
                  viewLess={ViewLess}
                  chaTagSentiment={() => chaTagSentiment()}
                  addIntent={(resp: any) => {
                    openDesc(resp);
                  }}
                />
              ) : (
                <MessageData
                  // contentChat=""
                  content={checkJson(message.content)}
                  viewMoreEvent={viewMore}
                  viewLessEvent={viewLess}
                  viewMore={ViewMore}
                  viewLess={ViewLess}
                  chaTagSentiment={() => chaTagSentiment()}
                  addIntent={(resp: any) => {
                    openDesc(resp);
                  }}
                  // alertData="old"
                />
              )}
            </Typography>
            {(message && checkJson(message.content).isMultiple) ||
            message.content.includes("Glossary") ||
            ViewMore !== true ||
            message.content.includes("don't") ? (
              ""
            ) : (
              <img
                src={ReverseLogo}
                onClick={() => handleBackData("left")}
                style={{
                  marginLeft: "3%",
                  width: "23px"
                }}
              />
            )}
            {(message && checkJson(message.content).isMultiple) ||
            message.content.includes("Glossary") ||
            ViewMore !== true ||
            message.content.includes("don't") ? (
              ""
            ) : (
              <img
                src={ForwardLogo}
                onClick={() => handleBackData("right")}
                style={{
                  marginLeft: "83%",
                  width: "23px"
                }}
              />
            )}
            {dictate && (
              <Dictate
                bucket={bucket}
                path={keyPath}
                voice={voice}
                text={toDictate}
                completed={finishedDictating}
                closeDictateCard={closeDictateCard}
              />
            )}
            {sentiment && (
              <div>
                <div className="text-dark">
                  <hr />
                </div>
                <span>
                  <small>Sentiment Analysis:</small>
                </span>{" "}
                <small>
                  <button
                    type="button"
                    className="close text-right"
                    aria-label="Close"
                    onClick={() => setSentiment(false)}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </small>
                <br />
                <DetectSentiment language="en" text={message.content} />
                <DetectEntities language="en" text={message.content} />
              </div>
            )}
            {selectedLanguage && (
              <TranslateCard
                closeTranslateCard={closeTranslateCard}
                dictateTranslated={dictateTranslated}
                selectedLanguage={selectedLanguage}
                applyState={applyState}
                text={messageData}
                mic={mic}
              />
            )}
          </CardContent>
          <br />
          <CardActions disableSpacing>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                {PermissionData &&
                PermissionData.Permissions.indexOf("chaTag") > -1 ? (
                  <IconButton
                    aria-label="add to favorites"
                    onClick={() => setChatOpen(true)}
                  >
                    ChaTag &trade;
                  </IconButton>
                ) : (
                  ""
                )}
                {PermissionData &&
                PermissionData.Permissions.indexOf("share") > -1 ? (
                  <IconButton aria-label="share" onClick={() => setShare()}>
                    <LightTooltip title="Share">
                      <ShareIcon />
                    </LightTooltip>
                  </IconButton>
                ) : (
                  ""
                )}
                {PermissionData &&
                PermissionData.Permissions.indexOf("QR-Code") > -1 ? (
                  <IconButton aria-label="share" onClick={() => QRCodes()}>
                    <LightTooltip title="QR-code">
                      <span>
                        <CropFreeIcon />{" "}
                        {expanded ? <ExpandLessIcon /> : <ExpandMore />}
                      </span>
                    </LightTooltip>
                  </IconButton>
                ) : (
                  ""
                )}
                {PermissionData &&
                PermissionData.Permissions.indexOf("comment") > -1 ? (
                  <IconButton aria-label="share" onClick={() => addComment()}>
                    <LightTooltip title="Comment">
                      <Chat />
                    </LightTooltip>
                  </IconButton>
                ) : (
                  ""
                )}
                <IconButton
                  className={clsx(classes.expand, {
                    [classes.expandOpen]: expanded
                  })}
                  style={{ float: "right" }}
                  onClick={event => openMessageAction(event)}
                  aria-expanded={expanded}
                  aria-label="show more"
                >
                  <ExpandMoreIcon />
                  <TranslateIcon />
                </IconButton>
              </Grid>
              <Grid item xs={12}>
                {/* <IconButton aria-label="share" onClick={() => setExpert()}> */}
                {PermissionData &&
                PermissionData.Permissions.indexOf("expert") > -1 ? (
                  <IconButton aria-label="share">Expert</IconButton>
                ) : (
                  ""
                )}
                {PermissionData &&
                PermissionData.Permissions.indexOf("sponsor") > -1 ? (
                  <IconButton
                    aria-owns={"message-actions"}
                    aria-haspopup="true"
                    onClick={sponsorHandleClick}
                  >
                    <span style={{ verticalAlign: "super" }}>Sponsor</span>
                    {sponsorOpen ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </CardActions>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <CardContent>
              {/* <Typography paragraph>{messageData}</Typography> */}
              {botText && (
                <QRCode
                  value={`https://honeycode.glossary.chat/${mainData &&
                    mainData.replace(/ /g, "_").toLowerCase()}`}
                  name={mainData}
                />
              )}
            </CardContent>
          </Collapse>
        </Card>
        <ChatTagAction
          open={chatOpen}
          saveChatTag={saveChatTag}
          client={client}
          chatClose={() => closeChatTag()}
        />
        {/* <ChatTagActionSent open={chatOpenSent} chatClose={() => closeChatTagSent()} messageData={message.content} saveChatTageData={saveChatTageData} handleChangeData={handleChangeData}/>  */}
        <CommentAction open={commentOpen} commentClose={() => closeComment()} />
        <ExpertAction
          open={expertOpen}
          expertClose={() => closeExpert()}
          client={client}
        />
        <ShareAction
          open={shareOpen}
          shareClose={() => closeShare()}
          url={`https://honeycode.glossary.chat/${mainData &&
            mainData.replace(/ /g, "_").toLowerCase()}`}
          name={mainData}
        />
      </div>
    </MuiThemeProvider>
  );
};

export default MessageBubble;
